module["exports"] = ["#{city_prefix} #{Name.last_name}", "#{Name.last_name}#{city_suffix}"];